const NAMESPACE = 'new-kuruma-store'
export const TOKEN = `${NAMESPACE}/token`
